<template lang="html">
  <div id="home-page">
    <loading-component-s2 v-if="isLoading"></loading-component-s2>

    <section class="banner-section overflow-hidden">
      <swiper class="swiper" :options="bannersOptions">
        <swiper-slide v-for="(banner, bInx) in banners.desktop" :key="'bInx-'+bInx">
          <div class="position-relative d-flex align-items-center justify-content-center box-swiper-element">
            <!-- Background -->
            <div class="position-absolute w-100 h-100 hero-bg" v-bind:style="{ backgroundImage: 'url('+banner.image+')' }" aria-hidden="true"></div>
            <div class="position-absolute w-100 h-100 hero-overlay" aria-hidden="true"></div>

            <!-- Content -->
            <div class="container position-relative text-center">
              <div class="row justify-content-center">
                <div class="col-12 col-lg-10 col-xl-8">
                  <h1 class="mb-3 text-white font-weight-bold hero-title">{{ banner.name }}</h1>
                  <p class="mb-4 text-white hero-subtitle">{{ banner.description }}</p>

                  <div class="d-flex flex-column flex-sm-row justify-content-center">
                    <a class="btn btn-bg-primary btn-lg px-5 mb-3 mb-sm-0 mr-sm-3" :href="banner.url">
                      Ver más
                    </a>

                    <router-link class="btn btn-bg-secondary btn-lg px-5" to="/productos">
                      Explorar otros productos
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>

    <section class="products-section py-5 bg-light">
      <div class="container">
        <!-- Header -->
        <div class="text-center mb-5">
          <h2 class="home2-products-title mb-4">
            Productos <span class="text-danger">Destacados</span>
          </h2>
          <p class="home2-products-subtitle mx-auto">
            Equipos de topografía, drones profesionales y tecnología de vanguardia. Compra en línea con envío seguro a
            todo México.
          </p>
        </div>

        <!-- Products Grid -->
        <div class="box-carousel mb-4">
          <swiper class="swiper swiper-carousel-s1" :options="productsOptions">
            <swiper-slide v-for="(product, pInx) in products" :key="'pInx-'+pInx">
              <div class="col-12 px-3 py-3 box-product-s1">
                <div class="card border-0 shadow-md product-card overflow-hidden">
                  <div class="position-relative">
                    <img class="w-100 placed-backg" src="public/images/pages/products/product.png" v-bind:style="{ backgroundImage: 'url('+ (product.image ? product.image : 'public/images/pages/products/placeholder.svg') +')' }" />
                    <span class="badge badge-primary product-badge-top-left">
                      {{ product.brand }}
                    </span>
                    <!-- <span
                      v-if="product.discount"
                      class="badge badge-success product-badge-top-right">
                      {{ product.discount }}
                    </span> -->
                    <div class="position-absolute" style="bottom: 1rem; right: 1rem;">
                      <span class="badge badge-success" v-if="product.stock == true">
                        En Stock
                      </span>
                      <span v-else class="badge badge-secondary">
                        Agotado
                      </span>
                    </div>
                  </div>

                  <div class="card-body p-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <span class="small font-weight-bold text-danger text-uppercase">
                        {{ product.category }}
                      </span>
                      <!-- <div class="d-flex">
                        <i
                          v-for="i in 5"
                          :key="i"
                          class="fa-solid fa-star text-warning"
                        ></i>
                      </div> -->
                    </div>

                    <h3 class="card-title product-name mb-3">
                      {{ product.name }}
                    </h3>

                    <div class="col-price mb-3">
                      <p class="d-block text-muted small text-decoration-line-through" v-if="product.price_offer">
                        $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} <small>USD</small>
                      </p>
                      <p class="product-price mb-0">
                        <span v-if="product.price_offer">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_offer) }} USD</span>
                        <span v-else>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} USD</span>
                      </p>
                    </div>

                    <ul class="list-unstyled mb-4" v-html="$root.generateProdList(product.keywords)">
                      <!-- <li
                        v-for="(feature, featureIndex) in product.keywords"
                        :key="featureIndex"
                        class="product-feature mb-2">
                        <i class="fa-solid fa-circle feature-bullet mr-2"></i>
                        {{ feature }}
                      </li> -->
                    </ul>

                    <div class="d-flex">
                      <router-link
                        class="btn btn-danger flex-grow-1 mr-2"
                        :class="{ 'disabled': !product.stock }"
                        :to="'/producto/'+$root._converToURL(product.name, product.id)">
                        <i class="fa-solid fa-cart-shopping mr-2"></i>
                        {{ product.stock ? 'Explorar' : 'Agotado' }}
                      </router-link>
                      <router-link class="btn btn-outline-danger" :to="'/producto/'+$root._converToURL(product.name, product.id)">
                        <i class="fa-solid fa-eye"></i>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="row mb-5">
          
        </div>

        <!-- CTAs -->
        <div class="row">
          <!-- Online Store CTA -->
          <div class="col-12 col-md-6 mb-4">
            <div class="home2-cta-card home2-cta-online-store text-white p-4">
              <h3 class="home2-cta-title mb-3">Tienda en Línea</h3>
              <p class="home2-cta-text mb-4">
                Compra fácil y seguro. Envío gratis en pedidos mayores a $50,000 MXN
              </p>
              <div class="d-flex flex-wrap mb-4">
                <span class="badge badge-light mr-2 mb-2 home2-cta-badge">Pago seguro</span>
                <span class="badge badge-light mr-2 mb-2 home2-cta-badge">Envío express</span>
                <span class="badge badge-light mb-2 home2-cta-badge">Garantía oficial</span>
              </div>
              <router-link
                to="/productos"
                class="btn btn-outline-light btn-lg"
              >
                Ver Catálogo Completo
                <i class="fa-solid fa-arrow-right ml-2"></i>
              </router-link>
            </div>
          </div>

          <!-- Custom Solutions CTA -->
          <div class="col-12 col-md-6 mb-4">
            <div class="home2-cta-card home2-cta-custom-solutions text-white p-4">
              <h3 class="home2-cta-title mb-3">Soluciones Personalizadas</h3>
              <p class="home2-cta-text mb-4">
                ¿Proyecto especial? Nuestros expertos diseñan la solución perfecta
              </p>
              <div class="d-flex flex-wrap mb-4">
                <span class="badge badge-light mr-2 mb-2 home2-cta-badge">Asesoría gratuita</span>
                <span class="badge badge-light mr-2 mb-2 home2-cta-badge">Cotización 24h</span>
                <span class="badge badge-light mb-2 home2-cta-badge">Soporte técnico</span>
              </div>
              <router-link
                to="/contacto"
                class="btn btn-light btn-lg"
              >
                Solicitar Cotización
                <i class="fa-solid fa-arrow-right ml-2"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="services-section py-5 text-white">
      <div class="container">
        <!-- Header -->
        <div class="text-center mb-5">
          <h2 class="home2-services-title mb-4">
            Servicios <span class="home2-gradient-text">Profesionales</span>
          </h2>
          <p class="home2-services-subtitle mx-auto">
            Ofrecemos soluciones integrales con la tecnología más avanzada para llevar tus proyectos al siguiente nivel
          </p>
        </div>

        <!-- Services Grid -->
        <div class="row">
          <div
            v-for="(service, index) in services"
            :key="index"
            class="col-12 col-md-6 col-lg-4 mb-4"
          >
            <div class="card border-0 shadow-lg home2-service-card">
              <div class="card-body p-4">
                <div class="home2-service-icon-wrapper mb-4">
                  <i :class="service.iconClass" class="home2-service-icon"></i>
                </div>

                <h3 class="card-title home2-service-title mb-3">
                  {{ service.title }}
                </h3>

                <p class="card-text home2-service-description mb-4">
                  {{ service.description }}
                </p>

                <ul class="list-unstyled mb-0">
                  <li
                    v-for="(feature, featureIndex) in service.features"
                    :key="featureIndex"
                    class="home2-service-feature mb-2"
                  >
                    <i class="fa-solid fa-circle feature-bullet mr-2"></i>
                    {{ feature }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      products: [],
      isLoading: true,

      services: [
        {
          iconClass: 'fa-solid fa-camera',
          title: 'Fotografía y Video Aéreo',
          description: 'Captura profesional en 4K y 8K para proyectos comerciales, inmobiliarios y eventos especiales.',
          features: ['Resolución hasta 8K', 'Estabilización profesional', 'Edición incluida'],
        },
        {
          iconClass: 'fa-sharp fa-regular fa-location-dot',
          title: 'Mapeo y Topografía',
          description: 'Levantamientos topográficos precisos y mapeo 3D para construcción e ingeniería.',
          features: ['Precisión centimétrica', 'Modelos 3D', 'Análisis de datos'],
        },
        {
          iconClass: 'fa-solid fa-building',
          title: 'Inspección Industrial',
          description: 'Inspecciones seguras de infraestructura, torres, paneles solares y estructuras complejas.',
          features: ['Cámaras térmicas', 'Zoom óptico 200x', 'Reportes detallados'],
        },
        {
          iconClass: 'fa-solid fa-bolt',
          title: 'Monitoreo en Tiempo Real',
          description: 'Vigilancia y monitoreo continuo para seguridad, agricultura y gestión de recursos.',
          features: ['Transmisión en vivo', 'IA integrada', 'Alertas automáticas'],
        },
        {
          iconClass: 'fa-solid fa-shield-halved',
          title: 'Capacitación Certificada',
          description: 'Cursos oficiales DJI y certificaciones para pilotos profesionales.',
          features: ['Certificación oficial', 'Práctica real', 'Soporte continuo'],
        },
        {
          iconClass: 'fa-solid fa-headphones',
          title: 'Soporte Técnico 24/7',
          description: 'Asistencia técnica completa, mantenimiento y reparaciones especializadas.',
          features: ['Respuesta inmediata', 'Técnicos certificados', 'Repuestos originales'],
        },
      ],

      // == Carousels ==
      bannersOptions: {
        effect: 'fade',
        loop: true,
        speed: 700,

        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      productsOptions: {
        slidesPerView: 3,
        spaceBetween: 0,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 0
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 0
          },
        }
      }
      // == ==
    }
  },

  methods: {
    getHome: function(){
      this.isLoading = true;
      axios.get(tools.url('/api/home')).then(({data}) =>{
        this.banners = data.banners;
        this.products = data.products;

        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      });
    },
  },

  mounted() {
    this.getHome();
  }
}
</script>
